import { EVENTLANDING_PAGE } from '@gameday/common/constants/endpoints'

export default {
  getLandingPage: EVENTLANDING_PAGE, // 'gamedayapi/eventlandingpage',
}
